import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { searchTeamsApi } from '../../../../api/api_football'
import Loader from '../../../Loader/Loader'

function SearchTeams({ selectedTeam, setSelectedTeam, type, teamName }) {
    const [teams, setTeams] = useState()
    const [searchTerm, setSearchTerm] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [requestCount, setRequestCount] = useState(0)

    useEffect(() => {
        if (!searchTerm && type && teamName) {
            setSearchTerm(teamName)
        }
    }, [type, teamName, searchTerm])

    useEffect(() => {
        async function search() {
            setIsLoading(true)
            try {
                const data = await searchTeamsApi(searchTerm)
                setTeams(data)
                console.log(data)
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        search()
    }, [requestCount])

    return (
        <div className="my-5">
            <div className="search-overlay-top shadow-sm">
                <div className="container container--narrow">
                    <input
                        autoFocus
                        className="live-search-field"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search for a team..."
                    />
                    <label
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                            setRequestCount((requestCount) => requestCount + 1)
                        }
                        htmlFor="live-search-field"
                        className="search-overlay-icon"
                    >
                        <i className="fas fa-search"></i>
                    </label>
                </div>
            </div>

            {isLoading && <Loader />}
            <div className="container">
                {teams?.map((team, index) => {
                    return (
                        <div className="card card-body" key={index}>
                            <div className="row">
                                <div className="col-1">
                                    <img
                                        src={team.logo}
                                        className="img-fluid teamLogo"
                                    />
                                </div>
                                <div className="col-10">
                                    <span>
                                        <Link to={`/teams-api/${team.team_id}`}>
                                            {team.name}
                                        </Link>
                                    </span>
                                    {type && (
                                        <div className="float-right">
                                            <div
                                                className={
                                                    selectedTeam?.team_id ===
                                                    team?.team_id
                                                        ? 'bg-success'
                                                        : ''
                                                }
                                                onClick={() =>
                                                    setSelectedTeam(team)
                                                }
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <i
                                                    className={
                                                        selectedTeam?.team_id ===
                                                        team?.team_id
                                                            ? 'fas fa-check'
                                                            : 'fas fa-plus'
                                                    }
                                                ></i>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default SearchTeams
